import React, { useState } from "react";

import Close from "../../../images/close-white.png";
import PostServiceApi from "../../../services/post-service";
import { NotificationManager } from "react-notifications";
import { Grid, Typography } from "@material-ui/core";

import FileUploader from "../file-uploader";
import { getUploadedFileId } from "../post/extensions";

function TopAdModal(props) {
  const [amount, setAmount] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [isBankTransfer, setIsBankTransfer] = useState(false);

  const freeBoostAdCount = props.ad.remainingFreeFeaturedCount;

  const selectCurrency = (id) => {
    setCurrency(id);
    props.changeSelectedCurrency(id);
  };

  const enteredAmount = (Val) => {
    setAmount(Val);
    props.changeSelectedAmount(Val);
  };

  const bankTransferHandle = (e) => {
    setIsBankTransfer(e.target.checked);
  };

  const handleTopAd = async () => {
    props.setLoading(true);
    try {
      let uploadedFileId = "";
      if (props.uploadedPaymentProof) {
        uploadedFileId = await getUploadedFileId({
          uploadedPaymentProof: props.uploadedPaymentProof,
          setLoading: props.setLoading,
        });
        if (!uploadedFileId) return;
      }
      const data = {};
      if (isBankTransfer) {
        data.paymentAmount = amount;
        data.paymentCurrency = currency;
        if (uploadedFileId) {
          data.paymentSlip = uploadedFileId;
        }
      }
      const response = await PostServiceApi.makeFeaturedAd({
        adId: props.adId,
        // data: {
        //   ...(isBankTransfer && {
        //     paymentAmount: amount,
        //     paymentCurrency: currency,
        //     ...(uploadedFileId && { paymentSlip: uploadedFileId }),
        //   }),
        // },
        data,
      });

      if (!response.success) {
        const errorStatusCode = response.body?.code;
        switch (errorStatusCode) {
          case 1520:
            NotificationManager.error("Post is already a Boost Ad", "Error");
            break;
          default:
            NotificationManager.error(
              "Failed to convert to a Boosted Ad",
              "Error"
            );
            break;
        }
        props.setLoading(false);
        return;
      }
      props.getAd();
      document.getElementById("topAdModalClose").click();
      NotificationManager.success(
        "Successfully converted to a Boost Ad",
        "Success"
      );
    } catch (error) {
      props.setLoading(false);
      NotificationManager.error("Failed to convert to a Boosted Ad", "Error");
      console.log(error);
    }
  };

  return (
    <div
      className="modal fade"
      id="topAdModal"
      tabIndex="-1"
      aria-labelledby="topAdModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered ">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="topAdModalLabel">
              Make Boost Ad
            </h5>
            <img
              src={Close}
              alt="close"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              width="50px"
              style={{ cursor: "pointer" }}
              id="topAdModalClose"
            />
          </div>
          <div className="modal-body">
            <p style={{ marginBottom: 20 }}>
              Do you want to make this Ad to a Boost Ad?
            </p>
            <p className="mb-3 font-weight-bold" style={{ fontSize: 14 }}>
              {`Remaining Free Boost Ads: ${freeBoostAdCount}`}
            </p>
            <div class="form-check" style={{ paddingBottom: 10 }}>
              <input
                class="form-check-input"
                type="checkbox"
                id="flexCheckDefault"
                checked={isBankTransfer}
                onChange={(e) => bankTransferHandle(e)}
              />
              <label class="form-check-label" for="flexCheckDefault">
                Bank Transaction
              </label>
            </div>
            {isBankTransfer && (
              <div>
                <div style={{ marginBottom: 10 }}>
                  <label
                    className="col-md-6 px-md-0 px-sm-2 mb-1"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Payment Currency *
                  </label>
                  <select
                    className="form-control col-md-8 px-sm-2 mb-1"
                    id="currency"
                    name="currency"
                    value={props.selectCurrency}
                    onChange={(e) => selectCurrency(e.target.value)}
                  >
                    <option defaultValue hidden>
                      -- Select --
                    </option>
                    <option value="USD">USD</option>
                    <option value="LKR">LKR</option>
                  </select>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label
                    className="col-md-6 px-md-0 px-sm-2 mb-1"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Payment Amount *
                  </label>
                  <input
                    onChange={(e) => enteredAmount(e.target.value)}
                    className="form-control col-md-8 px-sm-2 mb-1"
                    type="number"
                  />
                </div>
                <Grid container direction="column" style={{ rowGap: "8px" }}>
                  <Typography variant="body2" style={{ color: "#333333" }}>
                    Upload Payment Proof
                  </Typography>
                  <FileUploader
                    uploadedFile={props.uploadedPaymentProof}
                    setUploadedFile={props.setUploadedPaymentProof}
                  />
                </Grid>
              </div>
            )}
          </div>

          <div className="modal-footer border-0 p-2">
            <button type="button" className="btn" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              disabled={
                (isBankTransfer && (!amount || !currency)) ||
                (!isBankTransfer && freeBoostAdCount < 1)
              }
              onClick={() => handleTopAd()}
              style={{ width: 95 }}
            >
              {props.loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Yes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopAdModal;
